module.exports = "data:image/gif;base64,R0lGODlhHgAeALMAAB9MpQg5nDJbrS5Yq0NptH+ZzHOPx2eFwgAzmf///wAAAAAAAAAAAAAAAAAAAAAAACH5BAAAAAAALAAAAAAeAB4AAASiMMlJJQEhAFK7nwOSIGQ5Dt8nmCVLCinVijPdxuMs3Tnv1aJeUEj6AXcmpI6ycgV9QNiEl4QWWwVJqKhUDqsklPBjfYKHnTKZa2QnK4B3+k0nYeSVci2Dl9WBGn1TfzUbgl6DXyQch2NdbSlqHltofm5sFQV/iI8eTWagipV5TpyOHgZHpz4eBzWmrKhLVLEqTk5SOBIFIUQ0A1m6HhcZG7oRADs="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diving/cif.gif
// module id = fcK/
// module chunks = 1